import type { Campaign } from './data';

export const dealFields = [
  'offer_country_name',
  'offer_geo_area_level_1',
  'offer_opportunity_name',
  'offer_owner_name',
  'product_name',
  'vendor_name',
  'vendor_parent_name',
  'cost_currency',
] as const;
export function dealSelections(params: URLSearchParams): Record<string, Array<string>> {
  return Object.fromEntries(
    dealFields.map((field) => {
      const raw = params.get('fpDeal_' + field);
      if (raw === null) {
        return [field, field === 'product_name' ? ['Limited Time Lux Exclusive'] : []];
      }
      const values: unknown = JSON.parse(raw);
      if (!Array.isArray(values) || values.some((v) => typeof v !== 'string')) {
        throw new Error('Choose valid ' + field + ' source members.');
      }
      return [field, values];
    }),
  );
}
export function campaignChoices(campaigns: Array<Campaign>, params: URLSearchParams): Array<Campaign> {
  const selected = dealSelections(params),
    side = params.get('fpDealSide') === 'comparison' ? 'Comparison' : 'Current',
    search = (params.get('fpSearch' + side) ?? '').toLowerCase();
  return campaigns.filter(
    (c) =>
      dealFields.every((field) => !selected[field].length || selected[field].includes(c[field] ?? 'Unknown')) &&
      c.offer_opportunity_name.toLowerCase().includes(search),
  );
}
